import React from "react";
import CustomModal from "../../../Global/Modal/CustomModal";

const InviteCoachModal = ({ show, onHide, userData }) => {
  const footerButtons = [
    {
      title: "סגור",
      style: "grey",
      onClick: onHide,
    },
  ];

  return (
    <CustomModal
      isOpen={show}
      onClose={onHide}
      title="הזמנת מאמן חדש"
      subtitle="בקש מהמאמן להירשם באתר simplycoach.co ולהשתמש בקוד הארגון הבא:"
      footerButtons={footerButtons}
      width={40}
      height={40}
    >
      <div className="d-flex justify-content-center align-items-center gap-2 mb-4">
        <h4 className="mb-0" style={{ fontSize: "2rem" }}>
          {userData?.userOrganization?.organizationCode}
        </h4>
      </div>
    </CustomModal>
  );
};

export default InviteCoachModal;
